import m from "../../es2015/lang/fr_FR";
window.am4lang_fr_FR = m;


//////////////////
// WEBPACK FOOTER
// ./lang/fr_FR.js
// module id = null
// module chunks = 